import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.css'],
})
export class DisclaimerComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<DisclaimerComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
